export default function phonebookReducer(phonebook, action) {
  switch (action.type) {
    case "set":
      return action.value;

    default:
      return { ...phonebook, [action.type]: action.value };
  }
}
